function normalizeBaseUrl(raw: string): string {
    return raw.replace(/\/+$/, '');
}

function readEnvBaseUrl(): string | undefined {
    const candidates = [import.meta.env.VITE_API_BASE_URL, import.meta.env.VITE_API_URL];
    for (const raw of candidates) {
        if (typeof raw !== 'string') continue;
        const trimmed = raw.trim();
        if (trimmed) return normalizeBaseUrl(trimmed);
    }
    return undefined;
}

export const API_BASE_URL: string = (() => {
    const fromEnv = readEnvBaseUrl();
    if (fromEnv) return fromEnv;
    if (!import.meta.env.PROD) {
        return 'http://localhost:3000';
    }
    throw new Error(
        "Définissez VITE_API_BASE_URL ou VITE_API_URL (URL publique de l'API) pour le build de production.",
    );
})();
